export var getters = {
    favicon: function (state, g, rootState) {
        var _a, _b, _c, _d, _e, _f, _g;
        return (_g = (_d = (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.jobList) === null || _a === void 0 ? void 0 : _a.appearance) === null || _b === void 0 ? void 0 : _b.favicon) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : (_f = (_e = rootState.appearance) === null || _e === void 0 ? void 0 : _e.favicon) === null || _f === void 0 ? void 0 : _f.url) !== null && _g !== void 0 ? _g : null;
    },
};
